<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 17/07/28. -->

<template>
  <img
    :alt="alt"
    :src="src"
    :style="style"
    @click="click"
  />
</template>

<script>
export default {
  name: "WeexImage",
  data: () => ({
    src: "",
    style: "",
    alt: "EzCred"
  }),
  methods: {
    click() {
      this.$emit('click', {})
    }
  }
}
</script>
